module.exports = __webpack_public_path__ + "img/md.6b8abcb.svg";